import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, showDeleteDialog, Text, useSettings } from 'app/main/components';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

export default function WebsitesListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const editWebsite = () => {
		dispatch(
			showFastAddDialog({
				module: 'websites',
				isUpdate: true,
				model: props.model,
				maxDialogWidth: 'sm',
				updateRefresh: props.buttonProps.updateRefresh,
				additionalProps: { disableIdentityAssociation: true }
			})
		);
	};

	const deleteWebsite = () =>
		dispatch(
			showDeleteDialog({
				module: 'websites',
				id: props.model.webs_uid,
				title: props.model.webs_title,
				updateRefresh: props.buttonProps.updateRefresh
			})
		);

	const secondaryAction = (
		<>
			<IconButton size="small" onClick={editWebsite}>
				<Icon icon="pencil" />
			</IconButton>
			<IconButton size="small" onClick={deleteWebsite} edge="end">
				<Icon icon="delete" />
			</IconButton>
		</>
	);

	return (
		<GridListItem secondaryAction={secondaryAction}>
			<Grid container justifyContent="space-between" alignItems="center">
				<Grid size={12} className="inline-flex items-center">
					{/* WARNING */}
					{props.model.webs_warning_desc && (
						<Tooltip title={props.model.webs_warning_desc} arrow>
							<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
						</Tooltip>
					)}
					{/* BLOCKED */}
					{props.model.webs_blocked_desc && (
						<Tooltip title={props.model.webs_blocked_desc} arrow>
							<Icon className="mr-2" icon="block" color="error.main" />
						</Tooltip>
					)}
					{/* DESCRIPTION */}
					<Text className="font-600" variant="subtitle2">
						{props.model.webs_description || t('MODULE_WEBSITES_NAME_SINGULAR')}
					</Text>
				</Grid>
				<Grid size={12}>
					{/* WEBSITE */}
					<ButtonLink href={`${props.model.webs_title}`}>{props.model.webs_title}</ButtonLink>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
